import React from 'react'
import { FieldLabel } from '../form/index'
import ServiceSearchSelect from './ServiceSearchSelect'

const ServiceSearchSelectField = (props) => (
  <FieldLabel {...props} format={null} component={ServiceSearchSelect} />
)

export default ServiceSearchSelectField
